// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"2c83be80","154":"ab20b18f","279":"e31ab414","384":"f308bf66","398":"fea8f08d","441":"61cf47c9","605":"68812f8b","738":"62265f10","835":"507e70c0","894":"c704b7c1","905":"2f187b93","969":"fbd226d9"}[chunkId] + ".chunk.js";
};